$(document).ready(function() {  

  $.shifter({
    maxWidth: "740px"
  });  
  

  // Call Fancybox globally on all elements with class fancybox
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  }); 

  $('.flexslider').flexslider({
    animation: "fade",
    controlNav: true,
    slideshowSpeed: 6000,
    directionNav: true
  });
  
  var mobileMenuCont = $('.shifter-navigation .has-dropdown .has-dropdown_touch');
  mobileMenuCont.on('click', function(e) {
  	var mobileMenu = $(this).parent().find('> ul.sub');
    if( mobileMenu.css('display') == 'none' ) {
   	  e.preventDefault();
      $(this).parent().addClass('has-dropdown_active');
      mobileMenu.slideDown();
      e.stopPropagation();
    } else if( mobileMenu.css('display') == 'block' ) {
        e.preventDefault();
        $(this).parent().removeClass('has-dropdown_active');
        mobileMenu.slideUp();
        e.stopPropagation();
      }
    });

  $('.coll-filter').customSelect();

  

  //<![CDATA[
  jQuery(function() {
    jQuery('#sidebar ul li a').each(function() {
      if (jQuery(this).attr('href')  ===  window.location.pathname) {
        jQuery(this).addClass('current');
      }
    });
    				
    
  });  
  //]]>


}); 
/* theme edited by carlowseo*/

////////////////////张华明//////////////////
   

